import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropzone"];

  dragStart(event) {
    // Don't interfere with modal interactions
    if (event.target.closest('.modal')) {
      return;
    }
    
    event.dataTransfer.dropEffect = "copy";
    event.dataTransfer.setDragImage(event.currentTarget, 0, 0);
    this.draggedElement = event.currentTarget;
  }

  dragEnd() {
    this.draggedElement = null;
  }

  dragOver(event) {
    // Don't interfere with modal interactions
    if (event.target.closest('.modal')) {
      return;
    }
    
    event.preventDefault();
    this.dropzoneTarget.classList.add("dragging");
  }

  dragLeave(event) {
    // Don't interfere with modal interactions
    if (event.target.closest('.modal')) {
      return;
    }
    
    event.preventDefault();
    this.dropzoneTarget.classList.remove("dragging");
  }

  drop(event) {
    // Don't interfere with modal interactions
    if (event.target.closest('.modal')) {
      return;
    }
    
    if (this.draggedElement) {
      event.preventDefault();
      this.dropzoneTarget.classList.remove("dragging");

      // Try to find a link within the dragged element
      const link = this.draggedElement.querySelector("a");
      if (link) {
        link.click();
      } else {
        // Fallback: try to find any clickable element that might add the product
        const clickableElement = this.draggedElement.querySelector("[onclick], [data-action*='click']");
        if (clickableElement) {
          clickableElement.click();
        } else {
          // If the dragged element itself has an onclick handler, trigger it
          if (this.draggedElement.onclick) {
            this.draggedElement.onclick();
          }
        }
      }
    }
  }
} 